import React from 'react';
import { FaQuoteLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const DonorStories = () => {
  const navigate = useNavigate();
  const stories = [
    {
      name: "Rahul Sharma",
      role: "Regular Blood Donor",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      quote: "I've been donating blood for the past 5 years. It's a simple act that can save lives. The team at VALARCCI Foundation makes the process smooth and comfortable. I encourage everyone to join this noble cause.",
      location: "Hisar, Haryana"
    },
    {
      name: "Priya Patel",
      role: "Medical Student",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      quote: "As a medical student, I understand the critical need for blood donations. VALARCCI Foundation's work in organizing blood donation camps has been instrumental in saving countless lives in our community.",
      location: "Delhi"
    },
    {
      name: "Amit Kumar",
      role: "Community Volunteer",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      quote: "I've witnessed firsthand how blood donations can make a difference. The foundation's commitment to healthcare accessibility is truly inspiring. Their blood donation drives have helped many families in need.",
      location: "Rohtak, Haryana"
    }
  ];

  return (
    <div className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-[#eecda3] to-[#6dd5ed]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-black mb-4">Our Donor Stories</h2>
          <p className="text-xl text-black">Meet the heroes who make a difference through their donations</p>
        </div>

        <div className="space-y-24">
          {stories.map((story, index) => (
            <div 
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-12`}
            >
              {/* Image Section */}
              <div className="flex-1">
                <div className="relative">
                  <img 
                    src={story.image} 
                    alt={story.name}
                    className="w-full h-[400px] object-cover rounded-lg shadow-xl"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-lg"></div>
                  <div className="absolute bottom-4 left-4 text-white">
                    <h3 className="text-xl font-bold">{story.name}</h3>
                    <p className="text-sm">{story.location}</p>
                  </div>
                </div>
              </div>

              {/* Content Section */}
              <div className="flex-1 space-y-6">
                <div className="relative">
                  <FaQuoteLeft className="text-4xl text-blue-400 mb-4" />
                  <p className="text-lg text-black leading-relaxed italic">
                    {story.quote}
                  </p>
                </div>
                <div className="pt-4">
                  <h4 className="text-xl font-bold text-blue-400">{story.role}</h4>
                  <div className="mt-4 flex items-center space-x-2">
                    <div className="h-1 w-12 bg-blue-400"></div>
                    <span className="text-gray-600">Regular Donor</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl font-bold text-black mb-4">Be Part of Our Story</h3>
          <p className="text-lg text-black mb-8">
            Join our community of donors and make a difference in someone's life today
          </p>
          <button onClick={() => navigate('/contact')} className="bg-blue-400 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-blue-500 transition-colors duration-300 transform hover:scale-105">
            Become a Donor
          </button>
        </div>
      </div>
    </div>
  );
};

export default DonorStories; 